<template>
  <b-modal
    id="parameter-modal"
    ref="parameter-modal"
    :title="$t('title.parameterModal')"
    size="lg"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('control.button.save')"
    :cancel-title="$t('control.button.cancel')"
    @ok="onSubmit"
  >
    <div class="row">
      <div class="col-md-12">
        <b-card border-variant="primary">
          <div class="row">
            <div
              v-if="isParameter"
              class="col-md-6"
            >
              <b-form-group
                :label="$t('control.label.parameters.parameter.category')"
                label-for="category"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-select
                  id="category"
                  v-model="$v.form.categoryId.$model"
                  :options="categories"
                  value-field="id"
                  text-field="name"
                  :state="validateState('categoryId')"
                  :disabled="!form.isEditable"
                >
                  <template #first>
                    <b-form-select-option
                      :value="null"
                      disabled
                    >
                      -- {{ $t('control.option.category') }} --
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </div>
            <div
              v-if="isParameter"
              class="col-md-6"
            >
              <b-form-group
                :label="$t('control.label.parameters.parameter.key')"
                label-for="key"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-input
                  id="key"
                  v-model="$v.form.key.$model"
                  :state="validateState('key')"
                  :disabled="!form.isEditable"
                />
              </b-form-group>
            </div>
            <div class="col-md-9">
              <b-form-group
                :label="$t('control.label.parameters.parameter.title')"
                label-for="title"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-input
                  id="title"
                  v-model="$v.form.title.$model"
                  :state="validateState('title')"
                />
              </b-form-group>
            </div>
            <div
              v-if="isParameter"
              class="col-md-3"
            >
              <b-form-group
                :label="$t('control.label.parameters.parameter.amount')"
                label-for="amount"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-input
                  id="amount"
                  v-model="$v.form.amount.$model"
                  :state="validateState('amount')"
                />
              </b-form-group>
            </div>
            <div
              v-else
              class="col-md-3"
            >
              &nbsp;
            </div>
            <div class="col-md-12">
              <b-form-group
                :label="$t('control.label.parameters.parameter.description')"
                label-for="description"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-textarea
                  id="description"
                  v-model="$v.form.description.$model"
                  rows="3"
                  max-rows="3"
                  :state="validateState('description')"
                />
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                :label="$t('control.label.parameters.parameter.from')"
                label-for="from"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-datepicker
                  id="from"
                  v-model="$v.form.from.$model"
                  v-bind="$t('control.label.calendar')"
                  :state="validateState('from')"
                  locale="fr-BE"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :start-weekday="1"
                  :show-decade-nav="true"
                  :hide-header="true"
                />
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group
                :label="$t('control.label.parameters.parameter.to')"
                label-for="to"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-datepicker
                  id="to"
                  v-model="$v.form.to.$model"
                  v-bind="$t('control.label.calendar')"
                  :state="validateState('to')"
                  locale="fr-BE"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :start-weekday="1"
                  :show-decade-nav="true"
                  :hide-header="true"
                />
              </b-form-group>
            </div>
            <div class="col-md-5">
              <b-form-group
                :label="$t('control.label.parameters.parameter.color')"
                label-for="color"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-select
                  id="color"
                  v-model="$v.form.color.$model"
                  :state="validateState('color')"
                >
                  <b-form-select-option value="" />
                  <b-form-select-option
                    value="primary"
                    class="text-primary"
                  >
                    Primaire
                  </b-form-select-option>
                  <b-form-select-option
                    value="secondary"
                    class="text-secondary"
                  >
                    Secondaire
                  </b-form-select-option>
                  <b-form-select-option
                    value="success"
                    class="text-success"
                  >
                    Succes
                  </b-form-select-option>
                  <b-form-select-option
                    value="warning"
                    class="text-warning"
                  >
                    Warning
                  </b-form-select-option>
                  <b-form-select-option
                    value="info"
                    class="text-info"
                  >
                    Info
                  </b-form-select-option>
                  <b-form-select-option
                    value="danger"
                    class="text-danger"
                  >
                    Danger
                  </b-form-select-option>
                  <b-form-select-option
                    value="light"
                    class="text-light"
                  >
                    Light
                  </b-form-select-option>
                  <b-form-select-option
                    value="dark"
                    class="text-dark"
                  >
                    Dark
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-5">
              <b-form-group
                :label="$t('control.label.parameters.parameter.icon')"
                label-for="icon"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-select
                  id="icon"
                  v-model="$v.form.icon.$model"
                  :state="validateState('icon')"
                >
                  <b-form-select-option value="" />
                  <b-form-select-option value="ion-md-home">
                    Home
                  </b-form-select-option>
                  <b-form-select-option value="ion-md-megaphone">
                    Megaphone
                  </b-form-select-option>
                  <b-form-select-option value="ion-md-paper-plane">
                    Paper Plane
                  </b-form-select-option>
                  <b-form-select-option value="ion-md-warning">
                    Warning
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group
                :label="$t('control.label.parameters.parameter.order')"
                label-for="order"
                label-class="font-weight-normal text-secondary"
              >
                <b-form-input
                  id="order"
                  v-model="$v.form.order.$model"
                  :state="validateState('order')"
                />
              </b-form-group>
            </div>
            <div class="col-md-6 pt-3">
              <b-form-checkbox
                id="isEditable"
                v-model="$v.form.isEditable.$model"
                :state="validateState('isEditable')"
              >
                {{ $t('control.label.parameters.parameter.isEditable') }}
              </b-form-checkbox>
            </div>
            <div class="col-md-6 pt-3">
              <b-form-checkbox
                id="canBeDeleted"
                v-model="$v.form.canBeDeleted.$model"
                :state="validateState('canBeDeleted')"
              >
                {{ $t('control.label.parameters.parameter.canBeDeleted') }}
              </b-form-checkbox>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { masked, mask } from 'vue-the-mask';
import { validationMixin } from 'vuelidate';
import {
  required,
  requiredIf,
} from 'vuelidate/lib/validators';
import parameters from '../services/Parameters';
import categories from '../services/Categories';

export default {
  directives: { mask, masked },
  mixins: [validationMixin],
  data() {
    return {
      categories: [],
      isParameter: true,
      form: {
        id: 0,
        key: null,
        categoryId: null,
        title: null,
        amount: null,
        description: null,
        from: null,
        to: null,
        color: null,
        icon: null,
        isEditable: false,
        canBeDeleted: false,
        order: 1,
      },
      selected: [],
    };
  },
  mounted() {
    if (this.$store.getters['authorization/isAdministrator']) {
      this.$root.$on('updateParameterModal', (parameter, isMessage) => {
        this.update(parameter, isMessage);
      });
      this.$root.$on('newParameterModal', (isMessage) => {
        this.new(isMessage);
      });
      this.$root.$on('newMessageParameterModal', () => {
        this.newMessage();
      });
    }
  },
  validations: {
    form: {
      categoryId: {
        required: requiredIf((isParameter) => !isParameter),
      },
      key: {
        required: requiredIf((isParameter) => !isParameter),
      },
      title: {
        required,
      },
      amount: {
      },
      description: {
      },
      from: {
        required,
      },
      to: {
      },
      color: {
      },
      icon: {
      },
      isEditable: {
      },
      canBeDeleted: {
      },
      order: {
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        id: 0,
        categoryId: null,
        key: null,
        title: null,
        amount: null,
        description: null,
        from: null,
        to: null,
        color: null,
        icon: null,
        isEditable: true,
        canBeDeleted: false,
        order: 1,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$nextTick(async () => {
        parameters.baseUrl = this.$store.state.settings.apiBaseUrl;
        if (this.$store.getters['authorization/data'] != null) parameters.userId = this.$store.getters['authorization/data'].id;
        if (!this.isParameter) {
          if (Number(this.form.id) === 0) {
            this.form.categoryId = -1;
            this.form.key = 'dummy';
          }
          await parameters.putMessage(this.form.id, this.form);
          this.$root.$emit('forceUpdateMessages');
        } else await parameters.put(this.form.id, this.form);
        this.closeModal();
      });
    },
    showModal() {
      this.getCategories();
      this.$bvModal.show('parameter-modal');
    },
    closeModal() {
      this.$bvModal.hide('parameter-modal');
      this.$root.$emit('forceUpdateParameters');
    },
    new(isMessage) {
      this.isParameter = !isMessage;
      this.resetForm();
      this.showModal();
    },
    update(parameter, isMessage) {
      this.isParameter = !isMessage;
      this.form.id = parameter.id;
      this.form.categoryId = parameter.categoryId;
      this.form.key = parameter.key;
      this.form.title = parameter.title;
      this.form.amount = parameter.amount;
      this.form.description = parameter.description;
      this.form.from = parameter.from;
      this.form.to = parameter.to;
      this.form.color = parameter.color;
      this.form.icon = parameter.icon;
      this.form.isEditable = parameter.isEditable;
      this.form.canBeDeleted = parameter.canBeDeleted;
      this.form.order = parameter.order;
      this.showModal();
    },
    async getCategories() {
      categories.baseUrl = this.$store.state.settings.apiBaseUrl;
      const result = await categories.get();
      this.$nextTick(() => {
        // eslint-disable-next-line prefer-destructuring
        this.categories = result[1];
      });
    },
  },
};

</script>
